<template>
    <div class="contenido-notificacion">
        <div class="text-caption font-weight-bold mb-1">
            {{ fechaFormateada }}
        </div>

        <div class="text-h6 font-weight-bold primary--text texto-quebrable mb-3">
            {{ aviso.titulo }}
        </div>

        <!-- El mensaje va completo: en el listado se recorta a una linea, pero al
             abrir la notificacion se muestra entero y respetando los saltos que
             traiga el texto. -->
        <div class="text-body-1 black--text texto-mensaje">
            {{ aviso.mensaje }}
        </div>

        <!-- Solo los avisos que traen `ruta` desde el back muestran el boton. La
             navegacion la resuelve el contenedor: la card solo avisa. -->
        <div v-if="aviso.ruta" class="pt-5">
            <v-btn @click="$emit('irARuta', aviso)" elevation="0" width="200" color="primary" class="py-5">
                IR A {{ aviso.titulo }}
            </v-btn>
        </div>
    </div>
</template>

<script>
/**
 * Detalle de una notificacion. Componente presentacional: no sabe si lo estan
 * mostrando dentro del dialogo fullscreen (mobile) o embebido en la vista
 * (desktop). Recibe el aviso y lo dibuja, nada mas.
 */
export default {
    name: 'NotificacionCard',

    props: {
        aviso: {
            type: Object,
            required: true,
            default: () => ({}),
        },
    },

    computed: {
        fechaFormateada() {
            if (!this.aviso.fecha) return ''
            const fechaAviso = new Date(this.aviso.fecha)
            if (isNaN(fechaAviso.getTime())) return this.aviso.fecha
            return fechaAviso.toLocaleDateString('es-AR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            })
        },
    },
}
</script>

<style scoped>
/* Titulos largos cortan en varias lineas, nunca desbordan el ancho. */
.texto-quebrable {
    white-space: normal;
    word-break: break-word;
}

/* Igual, pero respeta los saltos de linea que traiga el mensaje. Con
   white-space: normal se colapsan y el texto queda todo pegado. */
.texto-mensaje {
    white-space: pre-line;
    word-break: break-word;
}

/* Alineado a la izquierda, SIN margen propio: el espaciado de arriba lo decide
   quien lo contiene (el dialogo lo quiere pegado al app-bar, la vista de
   escritorio le da aire). Un componente presentacional no manda sobre el
   espacio que lo rodea.
   El max-width se conserva porque un renglon de 1900px es ilegible: el ojo
   pierde donde empieza la linea siguiente. En mobile no llega a aplicar.
   El padding lateral evita que el texto toque los bordes en celular. */
.contenido-notificacion {
    max-width: 800px;
    margin: 0;
    padding-left: 16px;
    padding-right: 16px;
}
</style>
